import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
} from '@mui/material';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

import { CreateFolderRequest } from '@/types/document-folder';

import { useCreateFolder } from '@/api/document-folder';

interface CreateFolderModalProps {
  open: boolean;
  onClose: () => void;
  currentFolderId: number | null;
  propertyLocationId?: number;
  onSuccess?: () => void;
}

const CreateFolderModal: FC<CreateFolderModalProps> = ({
  open,
  onClose,
  currentFolderId,
  propertyLocationId,
  onSuccess,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<CreateFolderRequest>();

  const createFolderMutation = useCreateFolder();

  const onSubmit = async (data: CreateFolderRequest) => {
    const folderData: CreateFolderRequest = {
      ...data,
      parent_folder_id: currentFolderId || undefined,
      property_location_id: propertyLocationId,
    };

    await createFolderMutation.mutateAsync(folderData);

    // Reset form
    reset();

    // Close modal
    onClose();

    // Trigger success callback
    onSuccess?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: { xs: '90%', sm: 400 },
          maxWidth: { xs: '90%', sm: 500 },
        },
      }}
    >
      <DialogTitle>Create New Folder</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              fullWidth
              label="Folder Name"
              {...register('name', { required: 'Folder name is required' })}
              error={!!errors.name}
              helperText={errors.name?.message}
            />
            <TextField
              fullWidth
              label="Description (Optional)"
              multiline
              rows={3}
              {...register('description')}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={createFolderMutation.isPending}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={createFolderMutation.isPending}
          >
            {createFolderMutation.isPending ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateFolderModal;
